<ng-container *ngIf="pageMeta$ | async as meta">
  <nav class="breadcrumb">
    <span class="breadcrumb__section" *ngFor="let crumb of meta?.breadcrumbs; index as i">
      <cx-icon *ngIf="i !== 0" type="CARET_RIGHT"></cx-icon>
      <a
        *ngIf="i < meta?.breadcrumbs?.length - 1 || isVariant(meta.product); else onlyTitle"
        [routerLink]="crumb.link"
        [innerHTML]="crumb.label"
      ></a>
      <ng-template #onlyTitle>
        {{ crumb.label }}
      </ng-template>
    </span>
  </nav>
</ng-container>
